export default __webpack_public_path__ + "static/media/7_Forest Brook - 30s sample.485a9a02.mp3";